import { put, takeLatest } from 'redux-saga/effects'
import {
  GET_CHALLENGEQUESTIONS,
  GET_CHALLENGEQUESTIONS_FAILED,
  GET_CHALLENGEQUESTIONS_SUCCESSED,
} from '../actions/actionTypes'
import { ApiService } from '../services/ApiService'

const _apiService = new ApiService()
function* fetchChallengeQuestions() {
  try {
    let response = yield _apiService.getChallengeQuestions();

    if (!response || response.error) {
      yield put({
        type: GET_CHALLENGEQUESTIONS_FAILED,
        message: response.error || "An error has occured"
      })
    } else {
      var rebuildList = []
      response.challengeQuestions.forEach(item => {
        rebuildList.push({ 'label': item, 'value': item })
      })
      yield put({
        type: GET_CHALLENGEQUESTIONS_SUCCESSED,
        data: Object.assign({
        }, response, { questions: rebuildList })
      })
    }
  } catch (error) {
    yield put({
      type: GET_CHALLENGEQUESTIONS_FAILED,
      message: error.message
    })
  }

}

export function* watchFetchChallengeQuestions() {
  yield takeLatest(GET_CHALLENGEQUESTIONS, fetchChallengeQuestions)
}